var _rect, _text, _text2, _g, _line, _path, _rect2, _text3, _text4, _text5, _text6, _g2, _path2, _path3, _rect3, _text7, _text8, _text9, _text10, _rect4, _g3, _text11, _text12, _text13, _text14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3AFig2OnePassTwoOutputs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 560",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 560,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "One pass, two outputs")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Everything read once is either listed now or banked as inventory, nothing is wasted reading")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 130,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    fontWeight: 600,
    textAnchor: "middle"
  }, "9 SOURCES"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 145,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 164,
    textAnchor: "middle"
  }, "Anthropic"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 181,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 200,
    textAnchor: "middle"
  }, "Azure"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 217,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 236,
    textAnchor: "middle"
  }, "LangChain"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 253,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 272,
    textAnchor: "middle"
  }, "Factory"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 289,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 308,
    textAnchor: "middle"
  }, "Glean"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 325,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 344,
    textAnchor: "middle"
  }, "ProductSchool"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 361,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 380,
    textAnchor: "middle"
  }, "IBM"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 397,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#6366F1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 416,
    textAnchor: "middle",
    fill: "#6366F1"
  }, "Steiner 1972"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 433,
    width: 104,
    height: 30,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#6366F1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 452,
    textAnchor: "middle",
    fill: "#6366F1"
  }, "Levitis 2009")))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 300,
    x2: 220,
    y2: 300,
    stroke: "#D4DDD6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220 294 l10 6 l-10 6 z",
    fill: "#D4DDD6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 220,
    width: 240,
    height: 160,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 285,
    fontSize: 40,
    fontWeight: 700,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "287")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 312,
    fontSize: 14,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "candidates captured")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 336,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "179 plays, 35 playbooks,")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 352,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "73 frameworks")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490 300 C 540 300, 540 180, 588 180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 300 C 540 300, 540 400, 588 400"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M588 174 l10 6 l-10 6 z",
    fill: "#D4DDD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M588 394 l10 6 l-10 6 z",
    fill: "#D4DDD6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 606,
    y: 120,
    width: 346,
    height: 120,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 168,
    fontSize: 34,
    fontWeight: 700,
    fill: "#16A34A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "3")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 167,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "built and live this pass")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 196,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "batch 33, catalog 262 to 265, each with an")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 214,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "automated acceptance contract, priced at $20")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 606,
    y: 290,
    width: 346,
    height: 220,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#E2E8E4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 404,
    width: 298,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 424,
    width: 298,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 444,
    width: 270,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 464,
    width: 284,
    height: 12,
    rx: 3
  }))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 345,
    fontSize: 34,
    fontWeight: 700,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "284")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 716,
    y: 344,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "banked as inventory")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 373,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "tagged, deduplicated into 13 cross-source groups,")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 391,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "buildable later without returning to the sources")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3AFig2OnePassTwoOutputs);
export default __webpack_public_path__ + "static/media/case3a-fig2-one-pass-two-outputs.ec226b05cba2c10beefa6789f35286f2.svg";
export { ForwardRef as ReactComponent };